var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M158.088 121.912v-71.68c0-5.65-4.58-10.232-10.232-10.232h-15.712c-5.651 0-10.232 4.581-10.232 10.232v71.68h-71.68c-5.65 0-10.232 4.581-10.232 10.232v15.712c0 5.651 4.581 10.232 10.232 10.232h71.68v71.68c0 5.65 4.58 10.232 10.232 10.232h15.712c5.651 0 10.232-4.581 10.232-10.232v-71.68h71.68c5.65 0 10.232-4.581 10.232-10.232v-15.712c0-5.651-4.581-10.232-10.232-10.232z"
})));
export default SvgPlus;